import { CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';

export const getUser = (
    userPool: CognitoUserPool,
): Promise<null | CognitoUser> =>
    new Promise(resolve => {
        const cognitoUser = userPool.getCurrentUser();

        resolve(cognitoUser);
    });
